import { IListBoxItem, ListBoxItemType } from "azure-devops-ui/ListBox";

export const dropdownItems: Array<IListBoxItem<{}>> = [
    { id: "header", text: "Header", type: ListBoxItemType.Header },
    { id: "first", text: "first", groupId: "header" },
    { id: "divider", type: ListBoxItemType.Divider },
    { id: "header2", text: "Header 2", type: ListBoxItemType.Header },
    { id: "second", text: "second", groupId: "header2" },
    { id: "third", text: "third", groupId: "header2" },
    { id: "fourth", text: "fourth", groupId: "header2" },
    { id: "sixth", text: "sixth", groupId: "header2" },
    { id: "seventh", text: "seventh", groupId: "header2" },
    { id: "eighth", text: "eighth", groupId: "header2" },
    { id: "ninth", text: "ninth", groupId: "header2" },
    { id: "tenth", text: "tenth", groupId: "header2" },
    { id: "eleventh", text: "eleventh", groupId: "header2" },
    { id: "twelvth", text: "twelvth", groupId: "header2" },
    { id: "thirteenth", text: "thirteenth", groupId: "header2" },
    { id: "fourteenth", text: "fourteenth", groupId: "header2" },
    { id: "fifteenth", text: "fifteenth", groupId: "header2" }
];
